export enum TypeNodeEnum {
    city = 'city',
    project = 'project',
    chartType = 'chartType',
}
